import {
  Component,
  Input,
  ViewEncapsulation,
  OnInit,
  OnDestroy,
  output
} from '@angular/core';
import { BehaviorSubject, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, switchMap } from 'rxjs/operators';
import { TaskBase } from 'src/api';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import { NgTemplateOutlet } from '@angular/common';
import { MatExpansionPanel, MatExpansionPanelHeader } from '@angular/material/expansion';
import { InputV2Module } from '@schenck/rotec-components';
import { ImageSliderComponent } from '../../image-slider/image-slider.component';

export interface TaskInfoDetailItem {
  /**
   * Is put into the th element and translated.
   */
  name: string;
  /**
   * Is put into the td element and is not translated.
   */
  value: string;
}

@Component({
  selector: 'ma-task-info',
  templateUrl: './task-info.component.html',
  styleUrls: ['./task-info.component.less'],
  encapsulation: ViewEncapsulation.None,
  imports: [
    TranslatePipe,
    TranslateDirective,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    NgTemplateOutlet,
    InputV2Module,
    ImageSliderComponent
],
})
export class TaskInfoComponent<Task extends TaskBase> implements OnInit, OnDestroy {
  /**
   * The task.
   */
  @Input() public task: Task;
  /**
   * Additional details that should be shown inside the expandable.
   */
  @Input() public details: TaskInfoDetailItem[][];

  /**
   * Emits whenever user wants to change notes.
   */
  public readonly notesChange = output<string>();

  /**
   The operator is only able to view the data with readonly=true,
   while the admin has full permissions with readonly=false to add, update, and delete.
  */
  @Input() public readonly: boolean;
  public notes$ = new BehaviorSubject<string>(null);

  public ngOnInit(): void {
    // To prevent multiple calling BE when notes are changed
    this.notes$
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        filter((value) => !!value),
        switchMap((value) => of(value))
      )
      .subscribe((value: string) => this.notesChange.emit(value));
  }

  public ngOnDestroy(): void {
    this.notes$.complete();
  }
}
